define('components/course/models/slide-type/tei-wrapper',[
    'components/course/models/slide-type/zeus-base'
], function(Base) {
    "use strict";

    return Base.extend({
        "defaults": function() {
            var baseDefaults = Base.prototype.defaults.call(this),
                defaults = {
                    "isComplete": 0, // State if slide completed by user for submit button at last. Default - 0
                    "data": {
                        "saveState": {
                            "studentResponse": {
                                "assessmentGuid": null,
                                "items": []
                            }
                        }
                    }
                };
            return _.extend(baseDefaults, defaults);
        },

        "initialize": function() {
            this.populateDefaultData();
            this.get('data').studentResponseScore = 0;
        },

        "_getSaveStateJSONStructure": function() {
            return {
                "saveState": {
                    "studentResponse": {
                        "assessmentGuid": null,
                        "items": []
                    },
                    "lastLoadedIndex": null
                }
            };
        },

        "populateDefaultData": function() {
            var data = this.get('data');

            if (data && !data.saveState) {
                this.set('data', _.extend(data, this._getSaveStateJSONStructure()));
            }
            return this;
        },

        "getCurrentStudentScore": function() {
            var saveState = this.get('data').saveState,
                score = 0;

            if (saveState) {
                _.each(saveState.studentResponse.items, function(item) {
                    score += parseInt(item.tries[0].score, 10);
                }, this);
            }
            return score;
        }
    }, {

        "REPORTING_TYPES": {
            "STANDARD": "standard",
            "PRE_TEST": "pre-test",
            "POST_TEST": "post-test",
            "INTEREST_LEVEL": "interest-level"
        },

        "REPORTING_TYPE_DROPDOWN": [{
            "optionID": "standard",
            "optionValue": "standard",
            "optionText": "Standard"
        }, {
            "optionID": "pre-test-confidence",
            "optionValue": "pre-test",
            "optionText": "Pre-Test Confidence Rating"
        }, {
            "optionID": "post-test-confidence",
            "optionValue": "post-test",
            "optionText": "Post-Test Confidence Rating"
        }, {
            "optionID": "interest-level",
            "optionValue": "interest-level",
            "optionText": "Interest Level"
        }]
    });
});

